// Guards
import guards from './guards'
// GeneralViews
import NotFound from 'src/views/Pages/GeneralViews/NotFoundPage.vue'
import EmptyRouterView from 'src/views/Pages/GeneralViews/EmptyRouterView.vue'
// Layouts
import DashboardLayout from 'src/views/Layouts/DashboardLayout.vue'
// Auth
import Login from 'src/views/Pages/Auth/Login.vue'
import PasswordReset from 'src/views/Pages/Auth/PasswordReset.vue'
import Lock from 'src/views/Pages/Auth/Lock.vue'
// Dashboard pages
import Home from 'src/views/Pages/Dashboard/Home/Home.vue'
import User from 'src/views/Pages/Dashboard/User/UserProfile.vue'
// -------------------------------------------------------------------------------
// -------------------------- Configuraciones Nivel 2 ----------------------------
// -------------------------------------------------------------------------------
// Pages Maestros - Module
import Modules from 'src/views/Pages/Dashboard/Modules/Modules.vue'
import ModuleCreateEdit from 'src/views/Pages/Dashboard/Modules/ModuleCreateEdit.vue'
// Pages Maestros - Company
import Companies from 'src/views/Pages/Dashboard/Companies/Companies.vue'
import CompaniesCreateEdit from 'src/views/Pages/Dashboard/Companies/CompaniesCreateEdit.vue'
// Pages Maestros - Department
import Departments from 'src/views/Pages/Dashboard/Departments/Departments.vue'
// Pages Maestros - Role
import Roles from 'src/views/Pages/Dashboard/Roles/Roles.vue'
// Pages Maestros - Permission
import Permissions from 'src/views/Pages/Dashboard/Permissions/Permissions.vue'
// Pages Maestros - User
import Users from 'src/views/Pages/Dashboard/Users/Users.vue'
import UserCreateEdit from 'src/views/Pages/Dashboard/Users/UserCreateEdit.vue'

import Dashboard1 from "src/views/Pages/Demos/Dashboard1.vue";
import Dashboard2 from "src/views/Pages/Demos/Dashboard2.vue";

let dashboard1 = {
  path: "/demos",
  component: DashboardLayout,
  name: "Dashboard #1",
  children: [
    {
      path: "dashboard1",
      name: "Dashboard #1",
      component: Dashboard1,
    },
    {
      path: "dashboard2",
      name: "Dashboard #2",
      component: Dashboard2,
    },
  ]
};

let dashboard2 = {
  path: "/dashboard2",
  name: "Dashboard #2",
  component: Dashboard2,
};

let homePage = {
  path: '/',
  component: DashboardLayout,
  beforeEnter: guards.guest,
  redirect: '/home',
  children: [
    {
      path: 'home',
      name: 'inicio',
      component: Home
    },
    {
      path: 'profile',
      name: 'Usuario',
      component: User
    },
    {
      path: 'modules',
      component: EmptyRouterView,
      children: [
        {
          path: '',
          name: 'Modulos',
          component: Modules
        },
        {
          path: 'create',
          name: 'Crear Modulo',
          component: ModuleCreateEdit
        },
        {
          path: 'edit',
          name: 'Editar Modulo',
          component: ModuleCreateEdit,
        }
      ]
    },
    {
      path: 'companies',
      component: EmptyRouterView,
      children: [
        {
          path: '',
          name: 'Empresa',
          component: Companies
        },
        {
          path: 'create',
          name: 'Crear Empresa',
          component: CompaniesCreateEdit
        },
        {
          path: 'edit',
          name: 'Editar Empresa',
          component: CompaniesCreateEdit,
        }
      ]
    },
    {
      path: 'departments',
      name: 'Departamentos',
      component: Departments,
    },
    {
      path: 'roles',
      name: 'Perfiles',
      component: Roles,
    },
    {
      path: 'permissions',
      name: 'Permisos',
      component: Permissions,
    },
    {
      path: 'users',
      component: EmptyRouterView,
      children: [
        {
          path: '',
          name: 'Usuarios',
          component: Users
        },
        {
          path: 'create',
          name: 'Crear Usuario',
          component: UserCreateEdit
        },
        {
          path: 'edit',
          name: 'Editar Usuario',
          component: UserCreateEdit,
        }
      ]
    },
  ]
}

let loginPage = {
  path: '/login',
  name: 'Login',
  beforeEnter: guards.auth,
  component: Login
}

let loginGoogle =  {
  path: '/auth/:provider/callback',
  component: {
    template: '<div class="auth-component"></div>'
  }
}

let passwordResetPage = {
  path: '/password_reset/:token',
  name: 'PasswordReset',
  beforeEnter: guards.auth,
  component: PasswordReset
}

let lockPage = {
  path: '/lock',
  name: 'Lock',
  beforeEnter: guards.inactive,
  component: Lock
}

let notFoundPage = {
  path: '*',
  name: 'NotFound',
  component: NotFound
}

const routes = [
  dashboard1,
  dashboard2,
  homePage,
  loginPage,
  loginGoogle,
  passwordResetPage,
  lockPage,
  notFoundPage
]

export default routes
